export const headers = [
  { key: '_id', label: 'Timesheet ID' },
  { key: 'projectName', label: 'Project Name' },
  { key: 'taskName', label: 'Task Name' },
  { key: 'employeeName', label: 'Employee Name' },
  { key: 'hoursSpent', label: 'Hours Spent' },
  { key: 'date', label: 'Date' },
  { key: 'isBillable', label: 'Billable' }
];
